import { Component, OnInit } from '@angular/core';
import { RoutingInfoService } from '../../services/routingInfo.service';

// import { faFrown } from '@fortawesome/free-regular-svg-icons';
import { CdkDragStart } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotFoundComponent implements OnInit {
  backBtnDragging: any;
  previousRouteURL: any;
  router: any;

  // faFrown: any = faFrown;

  constructor(private routingInfoService: RoutingInfoService) {
    this.previousRouteURL = this.routingInfoService.previousUrlValue;
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  navigateBack() {
    if (this.backBtnDragging) {
      this.backBtnDragging = false;
      return;
    }

    if (this.previousRouteURL) {
      this.router.navigate([this.previousRouteURL]);
    } else {
      this.router.navigate(['dashboard/home']);
    }
  }

  handleDragStart(draggingEle: string, $event: CdkDragStart) {
    if (draggingEle === 'back-button') {
      this.backBtnDragging = true;
    }
  }
}
